import ReoptimizedLineupsViewInterface from './reoptimized-lineups-view-interface';
import LateswapCsvLineupInterface from 'src/components/organisms/late-swap/services/lineup-view/lateswap-csv-lineup-interface';

export class FanduelReoptimizedLineupsView implements ReoptimizedLineupsViewInterface {
    makeView(csvData: string[][], lateswapCsvLineups: LateswapCsvLineupInterface[]): string[][] {
        const view = csvData;

        if (isEmpty(lateswapCsvLineups)) {
            return view;
        }

        lateswapCsvLineups.map((lateswapCsvLineup, index) => {
            const lineupCells = lateswapCsvLineup.getDetails();

            lateswapCsvLineup.getPlayers().map((player) => lineupCells.push(player.getExternalId()));

            const rowNumber = 1 + index;

            lineupCells.map((lineupCell, index) => {
                view[rowNumber][index] = lineupCell;
            });
        });

        return view;
    }
}
